import type { ReactNode } from "react";
import { NotFoundPage } from "./NotFoundPage";
import {
  isEmeisBulkEnabled,
  isEmeisCalendarEnabled,
  isEmeisMonitorEnabled,
  isEmeisClauseEnabled,
  isEmeisReviewEnabled,
  isEmeisSubscriptionEnabled,
} from "../utils/emeisModuleFlags";

/** Section-level review pages: "not found" while the isEmeisReview switch is off. */
export function ReviewGate({ children }: { children: ReactNode }) {
  return isEmeisReviewEnabled() ? <>{children}</> : <NotFoundPage />;
}

/** Clause Library pages: "not found" while the isEmeisClause switch is off. */
export function ClauseGate({ children }: { children: ReactNode }) {
  return isEmeisClauseEnabled() ? <>{children}</> : <NotFoundPage />;
}

/** My Calendar and Notification Preferences: "not found" while the isEmeisCalendar switch is off. */
export function CalendarGate({ children }: { children: ReactNode }) {
  return isEmeisCalendarEnabled() ? <>{children}</> : <NotFoundPage />;
}

/** Subscription & Usage and License Management: "not found" while the isEmeisSubscription switch is off. */
export function SubscriptionGate({ children }: { children: ReactNode }) {
  return isEmeisSubscriptionEnabled() ? <>{children}</> : <NotFoundPage />;
}

/** Bulk upload of contracts and legacy contracts: "not found" while the isEmeisBulk switch is off. */
export function BulkGate({ children }: { children: ReactNode }) {
  return isEmeisBulkEnabled() ? <>{children}</> : <NotFoundPage />;
}

/** Application Status: "not found" while the isEmeisMonitor switch is off. */
export function MonitorGate({ children }: { children: ReactNode }) {
  return isEmeisMonitorEnabled() ? <>{children}</> : <NotFoundPage />;
}
